<!--
 Copyright (c) Qwoach LLC 2025. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 29/01/2025
-->

<template>
	<QwoachDialogLayout
		:title="dialogTitle"
		:is-loading="isProgressShowing"
		:loading-message="progressText">

		<div>
<!--			<div>-->
<!--				<div v-if="isKidsTemplate" class="mb-3">-->
<!--					Select the number of kids to add.-->
<!--&lt;!&ndash;					<span v-if="!hasExistingPartnersComputed">Partner will be added automatically. If no kids is selected, only a partner will be added.</span>&ndash;&gt;-->
<!--				</div>-->
<!--				<div v-else-if="isSiblingsTemplate" class="mb-3">-->
<!--					Select the number of siblings to add.-->
<!--&lt;!&ndash;					<span v-if="!hasExistingPartnersComputed">Parents will be added automatically. If no kids is selected, only parents will be added.</span>&ndash;&gt;-->
<!--				</div>-->
<!--			</div>-->
			<FormSelectRow
				class="mb-4"
				v-if="showPartnerSelect && hasExistingPartnersComputed"
				:options="partnerOptionsComputed"
				v-model="kidsMap.partner"
			/>
			<FormNumberRow
				prop="male"
				class="mb-2"
				title="Male"
				:label-min-width="labelMinWidth"
				v-model="kidsMap.male"
				width="100px"
				:range="range"
				placeholder="0"
			/>
			<FormNumberRow
				prop="male"
				class="mb-2"
				title="Female"
				v-model="kidsMap.female"
				:label-min-width="labelMinWidth"
				width="100px"
				:range="range"
				placeholder="0"
			/>

			<div>
				<div v-show="showAll">
					<FormNumberRow
						v-for="(nodeTypeOption, index) in uiNodeTypeOptionsComputed" :key="index"
						:prop="nodeTypeOption.value"
						class="mb-2"
						:title="nodeTypeOption.label"
						v-model="kidsMap[nodeTypeOption.value]"
						:label-min-width="labelMinWidth"
						width="100px"
						:range="range"
						placeholder="0"
					/>
				</div>
				<qw-link-button v-if="!showAll" @click="showAll=true">Show all symbol types</qw-link-button>
				<qw-link-button v-if="showAll" @click="showAll=false">Show less</qw-link-button>

			</div>
		</div>

	</QwoachDialogLayout>
</template>

<script>

import QwoachDialogLayout from "@/core/components/Dialogs/QwoachDialog/QwoachDialogLayout.vue";
import QwoachDialog from "@/core/components/Dialogs/QwoachDialog/QwoachDialog.vue";
import FormNumberRow from "@/core/components/Form/FormNumberRow.vue";
import FormSelectRow from "@/core/components/Form/FormSelectRow.vue";
import {
	getNodeTypesSymbolsOptions
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/defaults/node-types";
import {isObject} from "@/utils/helpers";
import {
	GenogramEnum
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/genogramUtils";

export default {
	name: "GenogramKidsTemplateDialog",
	extends: QwoachDialog,
	components: {FormSelectRow, FormNumberRow, QwoachDialogLayout},

	props: {
		existingPartners: Array,
		showPartnerSelect: Boolean,
		templateType: String,
	},

	data() {
		return {
			kidsMap: {
				partner: null,
				male: 0,
				female: 0,
			},
			range: [0, 10],
			labelMinWidth: 150,
			showAll: false,
		}
	},

	created(){
		this.setupKidsMap()
	},

	methods: {
		async createDataItem() {
			if(isObject(this.kidsMap.partner)){
				this.kidsMap.partner = this.kidsMap.partner.value
			}
			return this.kidsMap
		},

		setupKidsMap(){
			if(this.showPartnerSelect){
				this.kidsMap.partner = this.partnerOptionsComputed[0]
			}
		}
	},

	computed: {
		isSiblingsTemplate(){
			return this.templateType === GenogramEnum.SIBLINGS
		},
		isKidsTemplate(){
			return this.templateType === GenogramEnum.KIDS
		},
		hasExistingPartnersComputed(){
			return Array.isArray(this.existingPartners) && this.existingPartners.length > 0
		},

		nodeTypeOptionsComputed(){
			return getNodeTypesSymbolsOptions()
		},

		uiNodeTypeOptionsComputed(){
			return this.nodeTypeOptionsComputed.filter(option => option.value !== "male" && option.value !== "female")
		},

		partnerOptionsComputed(){
			let nodeTypeOptions = this.nodeTypeOptionsComputed
			let partnerOptions = []
			if(Array.isArray(this.existingPartners)){
				partnerOptions = this.existingPartners.map(partner => {
					let {id, name, type} = partner.data()
					if(!name){
						let nodeOption = nodeTypeOptions.find((item) => item.value === type)
						if(nodeOption){
							name = nodeOption.label + " Partner"
						}
					}
					return {
						value: id,
						label: name
					}
				})
			}

			partnerOptions.push({
				value: GenogramEnum.CREATE_PARTNER,
				label: 'Add new partner'
			})
			return partnerOptions
		},

		dialogTitle() {
			if(this.isSiblingsTemplate){
				return "Add Siblings"
			}
			return "Add Kids."//this.title
		},

		okButtonComputed() {
			return "Create"
		},
	}
}
</script>

<style lang="scss">

</style>
